import React, { useState } from 'react';
import {
  Outlet,
  useMatches,
  useNavigate
} from "react-router-dom";
import {
  Button,
  Col,
  Container,
  Image,
  Row,
  Tab,
  TabContent,
  Tabs
} from 'react-bootstrap';
import _ from "lodash";

import { 
  HiDotsCircleHorizontal,
  HiOutlineChevronLeft,
  HiPlusCircle
} from "react-icons/hi";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

import MessagesForm from '../../components/MessagesForm';
import ReviewForm from '../../components/ReviewForm';
import Reviews from '../../components/Reviews';
import ReviewsAlt from '../../components/ReviewsAlt';
import CustomizeRequestForm from '../../components/CustomizeRequestForm';


import useToken from '../../hooks/useToken';
import useUser from '../../hooks/useUser';
import updateSaasticAccountAction from '../../actions/updateSaasticAccountAction';
import sendAdminMessageAction from '../../actions/sendAdminMessageAction';

export default function Settings() {
  const { token } = useToken();
  const { user, setUser } = useUser();

  const navigate = useNavigate();

  const routerMatches = useMatches();

  // Alert states
  const [showSaveConfirm, setShowSaveConfirm] = useState(false);

  /*  State for each tab */
  // messages
  const [requestSubject, setRequestSubject] = useState();
  const [requestBody, setRequestBody] = useState();
  const [reminderSubject, setReminderSubject] = useState();
  const [reminderBody, setReminderBody] = useState();
  const [thanksPositiveSubject, setThanksPositiveSubject] = useState();
  const [thanksPositiveBody, setThanksPositiveBody] = useState();
  const [thanksNegativeSubject, setThanksNegativeSubject] = useState();
  const [thanksNegativeBody, setThanksNegativeBody] = useState();
  // form
  const [formTitle, setFormTitle] = useState();
  const [formBody, setFormBody] = useState();
  const [yelpLink, setYelpLink] = useState();
  const [googleLink, setGoogleLink] = useState();

  // customize
  const [integration, setIntegration] = useState();
  const [emailDomain, setEmailDomain] = useState();
  const [formHosting, setFormHosting] = useState();
  const [sms, setSms] = useState();
  const [hostReviews, setHostReviews] = useState();
  const [otherRequest, setOtherRequest] = useState();
  const [whenToContact, setWhenToContact] = useState();


  const pageName = () => {
    let page = routerMatches[routerMatches.length-1]['pathname'].split('/').reverse().find((val) => val !== "" && isNaN(val))
    return page;
  }

  const handleChange = (name, value) => {
    const setState = eval('set'+_.upperFirst(name));
    setState(value)
  };

  const updateSaastic = async (args) => {
    const response = await updateSaasticAccountAction(token, args);

    if(response.success) {
      if(!!response.data) {
        setUser(response.data);
      }
      setShowSaveConfirm(true);
      window.scrollTo(0,0);
    } else {
      alert('Could not save changes.');
    }
  }


  const sendRequest = async (args) => {
      
    let message = "Customer request:\n\n"
    message += integration ? "-integration\n" : "";
    message += emailDomain ? "-integration\n" : "";
    message += formHosting ? "-integration\n" : "";
    message += sms ? "-integration\n" : "";
    message += hostReviews ? "-integration\n" : "";
    message += otherRequest ? "-other: " + otherRequest + " \n" : "";
    message += whenToContact ? "\n\nContact preferences: " + whenToContact + " \n\n" : "";

    const response = await sendAdminMessageAction(token, { message });

    if(response.success) {
      setShowSaveConfirm(true);
      window.scrollTo(0,0);
    } else {
      alert('Could not send request.');
    }
  }

  return (
    <>
      <Container className="tab-settings g-0 mt-4 text-start">
	      <Row>
	      	<Col />
	      	<Col xs={12} >
		
            { showSaveConfirm && 
              <Alert severity="success" className="alert">
                { pageName()!="customize" && 
                  <AlertTitle>
                    Settings saved.
                  </AlertTitle>
                }
                { pageName()=="customize" && 
                  <>
                    <AlertTitle>
                      Request sent
                    </AlertTitle>
                    Thanks for reaching out! We will be in touch shortly. 
                  </>
                }
              </Alert>
            }

            { pageName()=="emails" && 
              <>
                <MessagesForm 
                  handleChange={handleChange} 
                />
                <div className="d-grid d-block col-xs-4 col-md-2 my-3 mx-auto">
                  <Button onClick={() => updateSaastic({
                    requestSubject,
                    requestBody,
                    reminderSubject,
                    reminderBody,
                    thanksPositiveSubject,
                    thanksPositiveBody,
                    thanksNegativeSubject,
                    thanksNegativeBody
                  })} variant="primary">
                    Save Changes
                  </Button>
                </div>
              </>
            }

            { pageName()=="form" && 
              <>
                <ReviewForm 
                  handleChange={handleChange} 
                />
                <div className="d-grid d-block col-xs-4 col-md-2 my-3 mx-auto">
                  <Button onClick={() => updateSaastic({
                    formTitle,
                    formBody,
                    googleLink,
                    yelpLink
                  })} variant="primary">
                    Save Changes
                  </Button>
                </div>
              </>
            }
            
            { pageName()=="reviews" && 
              <ReviewsAlt />
            }

            { pageName()=="customize" && 
              <>
                <CustomizeRequestForm 
                  handleChange={handleChange} 
                />
                <div className="d-grid d-block col-xs-4 col-md-2 my-3 mx-auto">
                  <Button onClick={() => sendRequest({
                    integration,
                    emailDomain,
                    formHosting,
                    sms,
                    hostReviews,
                    otherRequest,
                    whenToContact
                  })} variant="primary">
                    Send Request
                  </Button>
                </div>
              </>
            }
	      	</Col>
	      	<Col />
	      </Row>
      </Container>
    </>
  )
}